import { gql } from '@apollo/client';

export const GET_SCHEDULE = gql`
    query get_schedule($data: GetScheduleResolverInputType) {
        get_schedule(data: $data) {
            hasError
            data
            message
        }
    }
`;

export const LIST_CALENDARS = gql`
   query list_calendars($data: ListCalendarInputType) {
    list_calendars(data: $data) {
        hasError
        data
        message
    }
}
`;

export const UPDATE_SCHEDULE = gql`
 mutation update_scheduler($data: UpdateScheduleResolverInputType) {
    update_scheduler(data: $data) {
        hasError
        data
        message
    }
}
`;


export const LIST_CALENDARS_RULER = gql`
 query list_calendar_ruler($data: ListCalendarRulerInputType) {
    list_calendar_ruler(data: $data) {
        hasError
        data
        message
    }
}
`;
 